import * as React from "react";
import { TextInput, FormLink } from "soprasteria-ui-library";
import { formatOrganisationNumber } from "../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";
import { IClinic } from "../../../models/IClinic";
import { IOrganisation } from "../../../models/IOrganisation";
import { ORGANISATION } from "../../../utils/RouteConstants";
import { PostalAddressInformation } from "../../PostalAddress/PostalAddressInformation";
import { UserContext, isInRole } from "../../../contexts/UserContext";
import { MENUETTPORTALVA } from "../../../utils/RoleConstants";

interface IProps {
    clinic: IClinic;
    organisation: IOrganisation;
}

export const ClinicInformation: React.FunctionComponent<IProps> = ({ clinic, organisation }) => {
    const userInfo = React.useContext(UserContext);
    const hasRoleVA = isInRole(MENUETTPORTALVA, userInfo.roles ? userInfo.roles : []);

    return (
        <>
            <div className="col-6">
                {
                    hasRoleVA ?
                        <FormLink name="organisation" label="Vårdgivare" linkText={organisation.name} to={`/${ORGANISATION}/${organisation.organisationId}`} inlineLabel />
                        :
                        <TextInput label="Vårdgivare" name="readonly" defaultValue={organisation.name} readonly inlineLabel />
                }
                <TextInput label="Mottagning" name="readonly" defaultValue={clinic.name} readonly inlineLabel />
                <TextInput label="Mottagningsnummer" name="readonly" defaultValue={clinic.clinicNumber} readonly inlineLabel />

            </div>
            <div className="col-6">
                <TextInput label="Organisationsnummer" name="readonly" defaultValue={formatOrganisationNumber(organisation.organisationNumber)} readonly inlineLabel />
                <TextInput label="HSA-ID Mottagning" name="readonly" defaultValue={clinic.hsaId} readonly inlineLabel />
                <TextInput label="FK-nummer" name="readonly" defaultValue={clinic.fkNumber} readonly inlineLabel />
            </div>
            <div className="col-12">
                <hr />
                <h4>Besöksadress</h4>
            </div>
            <PostalAddressInformation address={clinic.visitingAddressAddress}
                zipCode={clinic.visitingAddressZipCode}
                city={clinic.visitingAddressCity}
                phoneNumber={clinic.visitingAddressPhoneNumber}
                alternativePhoneNumber={clinic.visitingAddressAlternativePhoneNumber}
                emailAddress={clinic.visitingAddressEmailAddress} />
        </>
    )
}